import type { XYChartVariantsInternal } from '../../types/xy-chart-internals.js';
import type { AreaSeriesStrategy } from '../strategies/area-series.js';
import type { BarSeriesStrategy } from '../strategies/bar-series.js';
import type { DotSeriesStrategy } from '../strategies/dot-series.js';
import type { LineSeriesStrategy } from '../strategies/line-series.js';
import type { RectSeriesStrategy } from '../strategies/rect-series.js';

export type ConcreteStrategy =
  | RectSeriesStrategy
  | DotSeriesStrategy
  | LineSeriesStrategy
  | BarSeriesStrategy
  | AreaSeriesStrategy;

export function getStrategyFactory(
  strategies: ConcreteStrategy[],
  seriesProps: XYChartVariantsInternal,
): ConcreteStrategy | undefined {
  return strategies.find((s) => s.canHandle(seriesProps));
}
